import { JsonPipe, KeyValuePipe, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { MiImageContainerComponent } from 'app/modules/shared/ui-sharable/mi-image-container/mi-image-container.component';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AppIcons } from '../../../../shared/app.icons';
import { AppSettings } from '../../../../shared/app.settings';
// import { PrintLabelsDialogComponent } from '../../../../shared/components/print-labels-dialog/print-labels-dialog.component';
import { CommonBindingDataService } from '../../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../../shared/services/entity.service';
// import { EventService } from 'app/modules/events/services/event.service';
import { GoogleMapsService } from 'app/modules/shared/services/google-map.services';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
// import { ManageZonesService } from 'app/modules/manage-zones/services/manage-zones.service';
import type { AttributeData, AttributeDataTab, FluffyGroup } from '../../../../shared/models/attribute.models';

interface DropdownItem {
  name: string;
  code: string;
}

interface SiteDetails {
  entityId: string;
  [key: string]: unknown;
}

interface SiteRowData {
  [key: string]: unknown;
}

interface DriverList {
  [key: string]: unknown;
}

@Component({
  selector: 'app-overview-details',
  standalone: true,
  imports: [ButtonModule, TranslateModule, DropdownModule, ChartModule, OverlayPanelModule, FormsModule,
    // PrintLabelsDialogComponent,
    MiImageContainerComponent, NgClass, KeyValuePipe,
    JsonPipe

  ],
  templateUrl: './overview-details.component.html',
  styleUrl: './overview-details.component.scss'
})
export class SiteOverviewDetailsComponent implements OnInit, OnChanges {
  miIcons = AppIcons;
  iconPos: 'left' | 'right' = 'right';
  @Input() attributeValues: Record<string, unknown>;
  @Input() attributeLabels: Record<string, string>;
  @Input() siteAttributeData: AttributeData;
  @Input() vehicleEntityId: string;
  @Input() siteRowData: SiteRowData;
  @Input() siteDetails: SiteDetails;
  @Input() driverList: DriverList[];
  @Input() isDeleted: boolean = false;
  @Input() isUnassigned: boolean = false;
  @Output() onToggleOverLay: EventEmitter<boolean> = new EventEmitter();

  dropDownItems: DropdownItem[] = [];
  selectedItem: DropdownItem[] = [];
  data: unknown;
  options: unknown;
  tab: AttributeDataTab;
  details: FluffyGroup;
  center: google.maps.LatLngLiteral = {
    lat: 24,
    lng: 12,
  };
  zoom = 4;
  map: google.maps.Map;
  bulkRowCount = 1;
  barcodeImage: string;
  visiblePrintLabel: boolean = false;
  rowData: SiteRowData;
  isLoading: boolean = false;
  selectedEventId: string;
  eventLat: number;
  eventLng: number;
  marker: google.maps.Marker;
  regionGeofences: Array<{ id: string; name: string }> = [];
  zoneIds: string[] = [];
  fields: Array<{ attributeCode: string;[key: string]: unknown }>;
  regionGeofence: { id: string; name: string };
  matchedZoneDisplayName: string = '';

  constructor(public vehicleService: EntityService,
    public cs: CommonBindingDataService,
    // private eventService: EventService,
    private googleMapsService: GoogleMapsService,
    private messageService: MessageService, private router: Router, private configService: ConfigService,
    private metaDataService: MetaDataService,
    // private manageZonesService: ManageZonesService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnChanges() {
    this.rowData = this.siteRowData;
  }

  ngOnInit() {

    if (this.siteAttributeData && this.siteAttributeData.tabs) {
      this.tab = this.siteAttributeData.tabs.find(ele => ele.tabCode === 'overview');
    }
    if (this.tab && this.tab.groups) {
      this.details = this.tab.groups.find(ele => ele.code === 'details');
    }
    this.dropDownItems = [
      { name: 'All Time', code: '' },
      { name: '1', code: '1' },
      { name: '2', code: '2' },
      { name: '3', code: '3' },
      { name: '4', code: '4' }
    ];
  }


  generateTemplate() {
    const country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    const labelQuantity = 1;
    const labelSize = 'small';
    const data = {
      forTenantCode: this.configService.getForTenantCode(),
      entityCode: AppSettings.ENTITY_CODE.PROTOCOL,
      countryCode: country[0].countryCode,
      entityIds: [this.siteDetails.entityId],
      labelQuantity,
      labelSize
    };
    this.isLoading = true;
    this.vehicleService.printLabels(data.entityCode, data).subscribe(res => {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: this.cs.getLabel('lbl_file_download_successfully') });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(res);
      a.download = 'Vehicle-QR-Sticker.pdf';
      a.click();
      this.visiblePrintLabel = false;
      this.isLoading = false;
    },
      () => { });
  }

  showPrintLabelDialog() {
    this.visiblePrintLabel = true;
  }

  scrollToTop() {

    const tabviewPanels = document.querySelector('.p-tabview-panels');
    if (tabviewPanels) {
      tabviewPanels.scrollTop = 0;
    }
  }

  redirectToEdit() {
    this.router.navigate([`/app/sites/add-site/${this.siteDetails.entityId}`]);
  }

  formatAddress() {
    const parts = [
      this.attributeValues.site_address_short_name,
      this.attributeValues.site_address_line_1,
      this.attributeValues.site_address_line_2,
      this.attributeValues.site_street,
      this.attributeValues.site_city,
      this.attributeValues.site_state,
      this.attributeValues.site_zip
 
    ].filter(Boolean);
    return parts.join(', ');
  }
  
}
